
import * as cloudflareRuntime$VhSMX3Tetz from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import * as vercelRuntime$b8uWPRx1qM from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/vercel'
import * as customRuntime$uLbWoupNrR from '/vercel/path0/providers/custom.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$VhSMX3Tetz, defaults: {"baseURL":"https://assets.pfsrealty.com"} },
  ['vercel']: { provider: vercelRuntime$b8uWPRx1qM, defaults: {} },
  ['custom']: { provider: customRuntime$uLbWoupNrR, defaults: undefined }
}
        